import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateRemoveUserEmployers = {
  removeUserEmployers: { data: null, loading: false, error: null },
};

export const removeUserEmployers = createAsyncThunk('user/removeUserEmployers', async ({ userId, employers }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .delete(`${process.env.REACT_APP_SERVER_API}/users/${userId}/employers`, {
      data: { employers },
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerRemoveUserEmployers = {
  [removeUserEmployers.pending]: (state) => {
    state.removeUserEmployers.data = null;
    state.removeUserEmployers.loading = true;
    state.removeUserEmployers.error = null;
  },
  [removeUserEmployers.fulfilled]: (state, action) => {
    state.removeUserEmployers.loading = false;
    state.removeUserEmployers.data = true;
    state.removeUserEmployers.error = null;
  },
  [removeUserEmployers.rejected]: (state, action) => {
    state.removeUserEmployers.data = null;
    state.removeUserEmployers.loading = false;
    state.removeUserEmployers.error = action.payload;
  },
};
